enum SettingsRouteDestination {
  ACCOUNT_LABEL_ROUTE = 'accountLabels',
  ADVANCED_INVOICING = 'advancedInvoicing',
  AGENCY_RATE_ROUTE = 'agencyRates',
  BANK_ACCOUNT_ROUTE = 'bankAccounts',
  CERTIFICATES_LIBRARY_ROUTE = 'certificates',
  COMMUNICATION_ROUTE = 'communications',
  DOMAIN_ROUTE = 'domains',
  GENERAL_ROUTE = 'general',
  INDEXATION_ROUTE = 'indexation',
  INTEGRATION_ROUTE = 'integrations',
  ROLE_ROUTE = 'roles',
  SUBSCRIPTION_ROUTE = 'subscription',
  TEAM_AND_MEMBERS_ROUTE = 'teamsAndMembers',
  TEMPLATE_ROUTE = 'templates',
  VARIOUS_OPERATION_ROUTE = 'variousOperations',
  SECURITY_LOGIN_ROUTE = 'securityLogin',
  LANGUAGE_PREFERENCE_ROUTE = 'languagePreferences',
  RECONCILIATION_ROUTE = 'reconciliation',
  LEGAL_ROUTE = 'legal',
  TECHNICS_LIBRARY_ROUTE = 'technics',
}

export default SettingsRouteDestination;
